"use client"

import { AuthUIProvider } from "@daveyplate/better-auth-ui"
import Link from "next/link"
import { useRouter } from "next/navigation"
import { ThemeProvider } from "next-themes"
import type { ReactNode } from "react"
import { Toaster } from "sonner"
import { authClient } from "@/lib/auth-client"

export function Providers({ children }: { children: ReactNode }) {
    const router = useRouter()

    return (
        <ThemeProvider
            attribute="class"
            defaultTheme="system"
            enableSystem
            disableTransitionOnChange
        >
            <AuthUIProvider
                authClient={authClient}
                organization={{
                    pathMode: "default",
                    logo: false,
                    customRoles: [
                        { role: "developer", label: "Developer" },
                        { role: "viewer", label: "Viewer" }
                    ]
                }}
                navigate={router.push}
                replace={router.replace}
                onSessionChange={() => {
                    // Clear router cache (protected routes)
                    router.refresh()
                    
                    // Redirect to home page after sign out
                    // if (!session) {
                        // router.push("/")
                    // }
                }}
                social={{
                    providers: [
                        // "github",
                        "google",
                        // "facebook",
                        // "apple",
                    ]
                }}
                multiSession={false}
                magicLink
                passkey
                // avatar={{
                //     upload: async (file) => {
                //         const formData = new FormData()
                //         formData.append("avatar", file)
                //         const res = await fetch("/api/uploadAvatar", { method: "POST", body: formData })
                //         const { data } = await res.json()
                //         return data.url
                //     },
                //     delete: async (url) => {
                //         await fetch("/api/deleteAvatar", {
                //             method: "POST",
                //             headers: { "Content-Type": "application/json" },
                //             body: JSON.stringify({ url })
                //         })
                //     },
                //     // Custom Image component for rendering avatar images
                //     // Useful for CDN optimization (Cloudinary, Imgix, ImgProxy, etc.)
                //     Image: Image // Use Next.js Image component for avatars
                // }}
                // captcha={{
                //     provider: "google-recaptcha-v3",
                //     siteKey: "your-site-key",
                // }}
                account={{
                    basePath: "/account",
                    fields: ["image", "name"]
                }}
                // twoFactor={["otp", "totp"]}
                Link={Link}
                localizeErrors={false}
                signUp={false}
                redirectTo="/dashboard"
                // optimistic={true}
            >
                {children}

                <Toaster
                    // closeButton // 👈 This adds a small 'X' to the top-right of every toast
                    // 'Infinity' makes the toast stay until the user clicks 'X'
                    swipeDirections={['right', 'left', 'top', 'bottom']}
                    duration={Infinity} 
                    // Ensures the toast appears at the top center like a banner
                    position="top-center" 
                    // Standard Maia styling props
                    expand={true}
                    richColors
                    theme="system"
                    toastOptions={{
                        closeButton: true,
                        // className: "rounded-xl border-maia-accent bg-white p-4 shadow-maia-lg",
                        // descriptionClassName: "text-slate-500 font-medium",
                        // Custom styling for error states specifically
                        // classNames: {
                        //     error: "bg-red-50 text-red-800 border-red-100",
                        //     success: "bg-green-50 text-green-800 border-green-100",
                        // },
                    }}
                />
            </AuthUIProvider>
        </ThemeProvider>
    )
}
